import { Link } from "react-router-dom";
import { Clock, MapPin, Phone } from "lucide-react";
import { SERVICES, SITE } from "@/data/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-brand-navydeep text-slate-300">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-12">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <img
              src="/images/logo-mark.png"
              alt="Advantage Primary Health"
              className="h-12 w-auto rounded-lg bg-white p-1.5"
            />
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-400">
              Military family-owned and operated primary care in Prescott Valley,
              Arizona. Care that fits your life—not the other way around.
            </p>
          </div>
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-brand-red">
              Services
            </p>
            <ul className="mt-4 space-y-2.5">
              {SERVICES.map((s) => (
                <li key={s.slug}>
                  <Link
                    to={`/services/${s.slug}`}
                    data-testid={`footer-service-${s.slug}`}
                    className="text-sm text-slate-400 transition-colors duration-200 hover:text-white"
                  >
                    {s.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-brand-red">
              Explore
            </p>
            <ul className="mt-4 space-y-2.5">
              <li><Link to="/" data-testid="footer-home-link" className="text-sm text-slate-400 transition-colors duration-200 hover:text-white">Home</Link></li>
              <li><Link to="/meet-jeremy" data-testid="footer-meet-jeremy-link" className="text-sm text-slate-400 transition-colors duration-200 hover:text-white">Meet Jeremy</Link></li>
              <li><Link to="/about" data-testid="footer-about-link" className="text-sm text-slate-400 transition-colors duration-200 hover:text-white">About Advantage</Link></li>
              <li><Link to="/insurance-new-patients" data-testid="footer-insurance-link" className="text-sm text-slate-400 transition-colors duration-200 hover:text-white">Insurance &amp; New Patients</Link></li>
              <li><Link to="/faqs" data-testid="footer-faqs-link" className="text-sm text-slate-400 transition-colors duration-200 hover:text-white">FAQs</Link></li>
              <li>
                <a href={SITE.bookUrl} target="_blank" rel="noopener noreferrer" data-testid="footer-book-online-link" className="text-sm font-semibold text-white transition-colors duration-200 hover:text-brand-red">
                  Book Online
                </a>
              </li>
            </ul>
          </div>
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-brand-red">
              Visit Us
            </p>
            <ul className="mt-4 space-y-3.5 text-sm text-slate-400">
              <li className="flex gap-2.5">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-brand-red" />
                <span data-testid="footer-address">{SITE.address}</span>
              </li>
              <li className="flex gap-2.5">
                <Phone className="mt-0.5 h-4 w-4 shrink-0 text-brand-red" />
                <a href={SITE.phoneHref} data-testid="footer-phone-link" className="transition-colors duration-200 hover:text-white">
                  {SITE.phone}
                </a>
              </li>
              <li className="flex gap-2.5">
                <Clock className="mt-0.5 h-4 w-4 shrink-0 text-brand-red" />
                <span data-testid="footer-hours">
                  {SITE.hours}
                  <br />
                  <span className="text-slate-500">{SITE.hoursNote}</span>
                </span>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-14 border-t border-white/10 pt-8">
          <p data-testid="footer-emergency-note" className="text-xs leading-relaxed text-slate-500">
            {SITE.emergencyNote}
          </p>
          <div className="mt-4 flex flex-wrap items-center justify-between gap-4">
            <p className="text-xs text-slate-500">
              © 2026 Advantage Primary Health. All rights reserved.
            </p>
            <Link
              to="/privacy-policy"
              data-testid="footer-privacy-link"
              className="text-xs text-slate-500 transition-colors duration-200 hover:text-white"
            >
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
